export * from './abstract-auth.provider';
export * from './dummy-auth.provider';
export * from './email-pass-auth.provider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@nebular/auth/providers/index.js
// module id = ../../../../@nebular/auth/providers/index.js
// module chunks = vendor